/**
 * AUTHENTICATED GUARD
 * ===================
 *
 * Garde minimale : exige uniquement un utilisateur Firebase Auth connecté
 * (email, Google ou téléphone), sans vérification d'appartenance équipe.
 *
 * Créé pour #331-B5 : `auth/complete-profile` était derrière TeamOnlyGuard,
 * qui compare `user.email` à la whitelist teamEmails. Or un compte phone-auth
 * n'a PAS d'email sur son token tant que complete-profile n'est pas passé →
 * en dev/acceptance (requireTeamAuth = true) les clients étaient redirigés
 * vers /team-login ou /unauthorized au lieu de pouvoir compléter leur profil.
 *
 * Redirige vers /auth (login client) avec returnUrl si non connecté.
 */

import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Auth } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard implements CanActivate {

  constructor(
    private auth: Auth,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    // Attendre la restauration de session depuis IndexedDB avant de lire
    // `currentUser` (même race que TeamOnlyGuard : première émission null
    // pour un user en réalité connecté).
    await this.auth.authStateReady();

    if (this.auth.currentUser) {
      return true;
    }

    console.warn('🚫 [AUTHENTICATED GUARD] Utilisateur non authentifié');
    return this.router.createUrlTree(['/auth'], {
      queryParams: { returnUrl: state.url }
    });
  }
}
